import "./App.css";

import Home from "./Pages/Home";
import Pricing from "./Pages/Pricing";
import SignUp from "./Components/Authentication/Sign/Sign";
import Contact from "./Pages/Contact";

import { Routes, Route } from "react-router-dom";

import { Provider } from "react-redux";
import { store } from './Store/Store'


function App() {
  return (
    <div className="App">
      <Provider store={store}>
      <Routes>
        <Route path="/" element={<Home />}/>
        <Route path="/pricing" element={<Pricing />}/>
        <Route path="/contact" element={<Contact />}/>
        <Route exact path="/signin" element={<SignUp />}/>
      </Routes>
      </Provider>
    </div>
  );
}

export default App;
